export function getStoredUser() {
  try {
    const user = localStorage.getItem("user");
    // Return null if user is null or undefined
    if (!user) return null;

    // Parse JSON string to object
    const parsedUser = JSON.parse(user || "{}");

    // Validate parsed user data
    if (!parsedUser || typeof parsedUser !== "object") {
      return null;
    }

    return parsedUser;
  } catch (error) {
    console.error("Error parsing user data:", error);
    // Clear invalid data from localStorage
    localStorage.removeItem("user");
    return null;
  }
}
